import type { EnvironmentVariable } from '@sb/remote-control/types';

import { getGlobalVariablesService } from './utils/getGlobalVariablesService';

export async function updateGlobalVariable(
  globalVariableId: string,
  updatedVariable: EnvironmentVariable,
): Promise<void> {
  await getGlobalVariablesService().patch(globalVariableId, {
    globalVariableItem: {
      ...updatedVariable,
      isGlobal: true,
      persistent: updatedVariable.persistent ?? false,
    },
  });
}
